export default "__VITE_ASSET__Cjg6TUiO__"